import {SharableEntityType} from 'common/report/util/saved-entities/types';
import {SearchDisplayContext} from 'common/report/util/search/types';
import {Content} from 'common/types/app-api/content';

const SHARABLE_ENTITY_TYPE_TO_SEARCH_DISPLAY_CONTEXT: Partial<Record<SharableEntityType, SearchDisplayContext>> = {
  [SharableEntityType.MetricTree]: SearchDisplayContext.MetricTree,
  [SharableEntityType.FeatureFlag]: SearchDisplayContext.FeatureFlag,
  [SharableEntityType.Experiment]: SearchDisplayContext.Experiment,
  [SharableEntityType.Dashboard]: SearchDisplayContext.Dashboard,
};

export function getSearchDisplayContext(content: Content) {
  return SHARABLE_ENTITY_TYPE_TO_SEARCH_DISPLAY_CONTEXT[content.content_type!] ?? SearchDisplayContext.Dashboard;
}
